import Content1 from "../../../assets/images/projects/blibli-illustration/content1.png";
import Content2 from "../../../assets/images/projects/blibli-illustration/content2.png";
import Content3 from "../../../assets/images/projects/blibli-illustration/content3-transparent.png";
import Content4 from "../../../assets/images/projects/blibli-illustration/content4-transparent.png";
import Content5 from "../../../assets/images/projects/blibli-illustration/content5-transparent.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Others: Illustrations",
  timeline: "Q4 - 2019",
  context:
    "A few showcase of illustrations that I made in the past couple of years. Mostly were started from sketch into digital.",
  team: [],
  thumbnail: "",
  contents: [
    {
      left: {
        title: "01. Illustration Medium (2020)",
        content: (
          <div>
            <p>
              This illustration is the cover of my Medium’s writings about “How
              Business Changes Designer’s Work in Technology Company.”
            </p>
            <p>
              I depicted a man inside the money as the symbolization of designer
              with apple laptop covered to the avocado logo that always in the
              ‘business’ life as I described it in my writings.
            </p>
          </div>
        ),
      },
      right: {
        content: <img alt="" src={Content1} width="100%" />,
      },
      bottomImage: "",
    },
    {
      left: {
        title: "02. Empty states illustrations (2019)",
        content: (
          <div>
            <p>
              Collborating with the senior UI Designer, I illustrated few empty
              states for the needs of Blibli in Internal System and Customer
              Facing Experiences. Building more fresh illustrations for Blibli
              so customer and user can get more delightful experinces in Blibli.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content2} width="100%" />,
      },
      bottomImage: "",
    },
    {
      left: {
        title: "03. New release Illustration for Blibli CNY’s eve (2018)",
        content: (
          <div>
            <p>
              In the constant improvement, Blibli has developed many release
              version to satisfy their customer. And on Chinese New Year event
              there was also improvement wrapped in new release for app that
              shared many improvements and the ‘juicy’ of Chinese New Year.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content3} width="100%" />,
      },
      bottomImage: "",
    },
    {
      left: {
        title: "04. Empty states for Blibli (2018)",
        content: (
          <div>
            <p>
              Have you ever confused when empty state or error occured? Stay
              calm 'cause Blibli will tell what it is with fun illustration and
              comprehensive wording!
            </p>
          </div>
        ),
      },
      bottomImage: Content4,
    },
    {
      left: {
        title: "",
        content: "",
      },
      bottomImage: Content5,
    },
  ],
} as ProjectDetailProps;
